import { Entity } from '@backstage/catalog-model';

/**
 * Check if Tech Insights is available for an entity.
 * The entity needs relevant annotations or basic metadata to display Tech Insights tab.
 * 
 * @param entity - The catalog entity to check
 * @returns true if Tech Insights should be displayed
 */
export const isTechInsightsAvailable = (entity: Entity): boolean => {
  const annotations = entity.metadata?.annotations || {};
  
  // Check for integration annotations:
  // 1. GitLab integration (for CI/CD checks)
  const hasGitLabProject = !!annotations['gitlab.com/project-slug'];
  // 2. Jira integration (for project management checks)
  const hasJiraProject = !!annotations['jira.com/project-key'];
  
  // Basic metadata (for basic health checks)
  const hasOwner = !!entity.spec?.owner;
  const hasDescription = !!entity.metadata?.description;
  
  // Show Tech Insights tab only when component has:
  // - GitLab integration (for CI/CD related checks)
  // - Jira integration (for project management checks)
  // - Basic metadata (owner and description for basic health checks)
  return hasGitLabProject || hasJiraProject || (hasOwner && hasDescription);
};

/**
 * Check if test reports are available for an entity.
 * The entity needs a link with title containing "report" or "报告" in metadata.links.
 * 
 * @param entity - The catalog entity to check
 * @returns true if test reports should be displayed
 */
export const isTestReportsAvailable = (entity: Entity): boolean => {
  const links = (entity?.metadata?.links ?? []) as { title?: string; url?: string }[];
  const reportsLink = links.find(link =>
    link?.title?.toLowerCase().includes('report') || link?.title?.includes('报告'),
  );
  return !!reportsLink?.url;
};

